import HeadboardBreadcrumbs from "./HeadboardBreadcrumbs";
import headboardBreadcrumbsAdapter from "./headboard-breadcrumbs.adapter";

export default HeadboardBreadcrumbs;
export { headboardBreadcrumbsAdapter };
